import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

import { lookupProducts } from '../services/delivery-runs.service';
import type { ProductLookupRequest } from '../types/delivery-runs.types';

/**
 * Batch product lookup on a connection — each id's latest audit row plus the
 * ids that matched nothing. Runs only when there is at least one id; the
 * result is keyed by the whole request so a changed id list or idType is a
 * fresh read.
 */
export function useProductLookup(
  connectionId: string,
  request: ProductLookupRequest,
  enabled = true,
) {
  const ids = request.ids.map((id) => id.trim()).filter(Boolean);
  return useQuery({
    queryKey: queryKeys.deliveries.productsLookup(connectionId, {
      ...request,
      ids,
    } as Record<string, unknown>),
    queryFn: () => lookupProducts(connectionId, { ...request, ids }),
    enabled: enabled && !!connectionId && ids.length > 0,
    staleTime: 15_000,
  });
}
